import { render, staticRenderFns } from "./EntitiesDialog.vue?vue&type=template&id=473e6296&scoped=true&"
import script from "./EntitiesDialog.vue?vue&type=script&lang=js&"
export * from "./EntitiesDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473e6296",
  null
  
)

export default component.exports